import React from 'react';
import ExamTiles from '../ExamTiles';
import ExamTile from '../ExamTile';

const Amc8Exams = ({ product, disabled }) => {
  return (
    <ExamTiles>
      <ExamTile
        title="AMC 8 Demo"
        length="25 questions; 40 min"
        remaining={-1}
        iconClass="fad fa-function"
        product={product}
        disabled={disabled}
      />
    </ExamTiles>
  );
};

export default Amc8Exams;
